import { useEffect, useState } from 'react';
import { fetchCustomAttributeData } from '../../services/magento/api';
import {getLabelFromCustomAttributeValue} from './helper'
import '../styles/ProductPage.css';

const StepPreview = ({ data, updateData }) => {
  const bundle = data.bundle;
  const [colorOptions, setColorOptions] = useState([]);
  const [sizeOptions, setSizeOptions] = useState([]);

  useEffect(() => {
    const fetchOptions = async () => {
      const colorData = await fetchCustomAttributeData('138'); // select_color
      const sizeData = await fetchCustomAttributeData('154');  // fashion_size
      setColorOptions(colorData);
      setSizeOptions(sizeData);
    };
    fetchOptions();
  }, []);

  // Use customizedItems from data
  const additionalItems = [
    ...(data.customizeOne || []),
    ...(data.customizeTwo || []),
    ...(data.customizeThree || [])
  ];

  const total =
    (bundle?.price || 0) +
    additionalItems.reduce((sum, i) => sum + (i.price || 0), 0);

  const handleRemove = (id) => {
    updateData({
      customizeOne: (data.customizeOne || []).filter(item => item.id !== id),
      customizeTwo: (data.customizeTwo || []).filter(item => item.id !== id),
      customizeThree: (data.customizeThree || []).filter(item => item.id !== id),
    });
  };

  const pages = ['First Preference', 'Second Preference', 'Third Preference'];
  let currentPageIndex = 0;
  let stepProgress = 0;

  return (
    <div className="preview-step-container">
      <h2>Review Your Selection</h2>

      {/* Bundle Summary */}
      <div className="selected-items-preview">
        <h3>Selected Bundle</h3>
        {bundle ? (
          <div className="selected-item">
            {bundle.image ? (
              <img src={bundle.image} alt={bundle.name} className="item-image" />
            ) : (
              <div className="item-image placeholder">{bundle.name?.charAt(0)}</div>
            )}
            <div className="item-details">
              <h4>{bundle.name}</h4>
{/*               <p>${bundle.price?.toFixed(2)}</p> */}
              {bundle.details && <p dangerouslySetInnerHTML={{ __html: bundle.details ?? '' }} />}
            </div>
          </div>
        ) : (
          <p>No bundle selected.</p>
        )}
      </div>

      {/* Additional Items */}

      <div className="selected-items-preview">
        <h3>Additional Item Selections</h3>

        {additionalItems.length === 0 ? (
          <p>No additional items selected.</p>
        ) : (
          <ul>
            {additionalItems.flatMap((item, index) => {
              const tierWeight = item.tier === 'tier2' ? 1 : 0.5;

              const output = [];

              if (stepProgress >= 1 || index === 0) {
                if (currentPageIndex < pages.length) {
                  output.push(
                    <li key={`title-${currentPageIndex}`} className="step-title">
                      <h4>{pages[currentPageIndex]}</h4>
                    </li>
                  );
                  currentPageIndex++;
                  stepProgress = 0;
                }
              }

              output.push(
                <li key={item.id} className="selected-item">
                  <div className="box">
                    <span>
                      {item.name}{' '}
                      {getLabelFromCustomAttributeValue(sizeOptions, item.selectedSize)}{' '}
                      {getLabelFromCustomAttributeValue(colorOptions, item.selectedColor)}
                    </span>
                    <span className={`tag ${item.tier}`}>
                      {item.tier === 'tier2' ? 'Premium' : 'Standard'}
                    </span>
                  </div>
                  <button
                    className="remove-btn"
                    onClick={() => handleRemove(item.id)}
                    aria-label={`Remove ${item.name}`}
                  >
                    🗑️
                  </button>
                </li>
              );

              stepProgress += tierWeight;

              return output;
            })}
          </ul>
          
        )}
      </div>
      <div className="total-section">
{/*         <strong>Total: </strong>${total.toFixed(2)} */}
      </div>
    </div>
  );
};

export default StepPreview;
